import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Company } from '@models/company';
import { FireInsuranceBrokerage } from '@models/brokerage';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { MatterDispatch } from '@state/matter';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { NavigationService } from 'src/app/shared/services/nav/nav.service';
import { TestHooks } from './edit-fire-insurance-brokerage.hooks';

@Component({
	selector: 'app-edit-fire-insurance-brokerage',
	templateUrl: './edit-fire-insurance-brokerage.component.html',
	standalone: false,
})
export class EditFireInsuranceBrokerageComponent {
	testHooks = TestHooks;
	@SelectSnapshot(SelectedMatter.id) matterId: string;

	public fireInsuranceBrokerage: FireInsuranceBrokerage;

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private navigationService: NavigationService,
		private matterDispatch: MatterDispatch,
	) {
		this.fireInsuranceBrokerage =
			this.router.getCurrentNavigation()?.extras?.state?.fireInsuranceBrokerage;

		if (!this.fireInsuranceBrokerage) {
			this.navigationService.goBack(this.route);
		}
	}

	_onSubmit(fireInsuranceBrokerage: FireInsuranceBrokerage) {
		this.matterDispatch.CreateFireInsuranceBrokerage(
			this.matterId,
			fireInsuranceBrokerage,
		);
		this.navigationService.goBack(this.route);
	}

	_onCancel() {
		this.navigationService.goBack(this.route);
	}
}
